const hljs = require("highlight.js");

function codeHighlight(str, lang) {
    const codeIndex = Date.now() + Math.floor(Math.random() * 10000000);
    let html = `<button class="copy-btn" type="button" data-clipboard-action="copy" data-clipboard-target="#copy${codeIndex}">复制</button>`;

    // 分割并过滤掉最后一个多余的空行
    const lines = str.split(/\r?\n/).filter((line, index, arr) => !(line.trim() === "" && index === arr.length - 1));
    const linesLength = lines.length;

    // 行号占位符
    let linesNum = '<span aria-hidden="true" class="line-numbers-rows">';
    for (let index = 0; index < linesLength; index++) {
        linesNum += "<span></span>";
    }
    linesNum += "</span>";
    if (lang && hljs.getLanguage(lang)) {
        try {
            const preCode = hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
            html += preCode;

            if (linesLength) {
                html += `<b class="name">${lang}</b>`;
            }
            return `<pre class="hljs"><code>${html}</code>${linesNum}</pre>
                    <textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">
                        ${str.replace(/<\/textarea>/g, "&lt;/textarea>")}</textarea>`;
        } catch (error) {
            console.error("Highlight error:", error);
        }
    }

    // 回退：如果语言不支持，则仅转义 HTML
    const escaped = str.replace(/<\/textarea>/g, "&lt;/textarea>");
    html += escaped;

    return `<pre class="hljs"><code>${html}</code>${linesNum}</pre><textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">${escaped}</textarea>`;
}

// 如果代码块中存在空白行，会导致高亮渲染时出现嵌套pre标签，丢失高亮效果，且好像是MarkdownIt的默认行为，无法控制。
// 如果存在空白行，则先去除，再进行渲染
function preprocess(content) {
    return content
        .replace(/^\s+|\s+$/g, '') // 去除首尾空白
        .replace(/\n{2,}/g, '\n'); // 合并多个空行为一个
}
export const markdown = (mavonEditor, content) => {
    const md = mavonEditor.getMarkdownIt();
    // 预处理内容
    content = preprocess(content);
    return md.set({
        highlight: codeHighlight
    }).render(content);
};

// 需要在写笔记的时候就手动去除代码块中的空白行
// export const markdown = (mavonEditor, content) => {
//     const md = mavonEditor.getMarkdownIt();
//     return md
//         .set({
//             highlight: function (str, lang) {
//                 const codeIndex =
//                     parseInt(Date.now()) + Math.floor(Math.random() * 10000000);
//                 let html = `<button class="copy-btn" type="button" data-clipboard-action="copy" data-clipboard-target="#copy${codeIndex}">复制</button>`;

//                 const linesLength = str.split(/\n/).length - 1;
//                 let linesNum = '<span aria-hidden="true" class="line-numbers-rows">';
//                 for (let index = 0; index < linesLength; index++) {
//                     linesNum = linesNum + "<span></span>";
//                 }
//                 linesNum += "</span>";
//                 if (lang && hljs.getLanguage(lang)) {
//                     try {
//                         // the old api
//                         // const preCode = hljs.highlight(lang, str, true).value;
//                         // the new api
//                         const preCode = hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
//                         html = html + preCode;
//                         if (linesLength) {
//                             html += '<b class="name">' + lang + "</b>";
//                         }
//                         return `<pre class="hljs"><code>${html}</code>${linesNum}</pre>
//                                 <textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">
//                                     ${str.replace(
//                             /<\/textarea>/g,
//                             "&lt;/textarea>"
//                         )}</textarea>`;
//                     } catch (error) {
//                         console.log(error);
//                     }
//                 }
//                 const preCode = md.utils.escapeHtml(str);
//                 html = html + preCode;
//                 return `<pre class="hljs"><code>${html}</code>${linesNum}</pre><textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">${str.replace(
//                     /<\/textarea>/g,
//                     "&lt;/textarea>"
//                 )}</textarea>`;
//             },
//         })
//         .render(content);
// };

// 原始版本
// const hljs = require("highlight.js")
//
// export const markdown = (mavonEditor, content) => {
//     const md = mavonEditor.getMarkdownIt();
//     return md
//         .set({
//             highlight: function (str, lang) {
//                 const codeIndex = parseInt(Date.now()) + Math.floor(Math.random() * 10000000);
//                 let html = `<button class="copy-btn" type="button" data-clipboard-action="copy" data-clipboard-target="#copy${codeIndex}">copy</button>`;
//                 const linesLength = str.split(/\n/).length - 1;
//                 let linesNum = `<span aria-hidden="true" class="line-numbers-rows">`;
//                 for (let index = 0; index < linesLength; index++) {
//                     linesNum = linesNum + "<span></span>"
//                 }
//                 linesNum += "</span>";
//                 if (lang && hljs.getLanguage(lang)) {
//                     try {
//                         const preCode = hljs.highlight(lang, str, true).value;
//                         html = html + preCode;
//                         if (linesLength) {
//                             html += `<b class="name">` + lang + "</b>"
//                         }
//                         return `<pre class="hljs"><code>${html}</code>${linesNum}</pre><textarea style="position: absolute;
//                         top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">${str.replace(
//                             /<\/textarea>/g,
//                                 "&lt;/textarea>"
//                         )}</textarea>`;
//                     } catch (error) {
//                         console.log(error);
//                     }
//                 }
//                 const preCode = md.utils.escapeHtml(str);
//                 html = html + preCode;
//                 return `<pre class="hljs"><code>${html}</code>${linesNum}</pre><textarea style="position: absolute;
//                 top: -9999px; left: -9999px; z-index: -9999;" id="copy${codeIndex}">${str.replace(
//                     /<\/textarea>/g,
//                     "&lt;/textarea>"
//                 )}</textarea>`;
//             },
//         })
//         .render(content);
// };
